
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class RisorseGrid extends Serenity.EntityGrid<RisorseRow, any> {
        protected getColumnsKey() { return RisorseColumns.columnsKey; }
        protected getDialogType() { return RisorseDialog; }
        protected getIdProperty() { return RisorseRow.idProperty; }
        protected getInsertPermission() { return RisorseRow.insertPermission; }
        protected getLocalTextPrefix() { return RisorseRow.localTextPrefix; }
        protected getService() { return RisorseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            this.openDialogsAsPanel = true;
        }
    }
}